import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AccountService } from '../../../login/account.service';
import { MessageService } from '../../../shared/message.service';

let unauthorizedMessageDisplayed = false;

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const accountService = inject(AccountService);
  const messageService = inject(MessageService);

  if (req.url.startsWith('/assets') || req.url.includes('/version.json')) {
    return next(req);
  }

  const token = localStorage.getItem('token');
  const publicPaths = ['/auth/login', '/auth/validate-otp', '/support-email'];
  const isPublicEndpoint = publicPaths.some(path => req.url.includes(path));

  if (token) {
    unauthorizedMessageDisplayed = false;
  }

  const showSessionExpiredMessage = () => {
    if (!unauthorizedMessageDisplayed) {
      unauthorizedMessageDisplayed = true;
      messageService.showError(
        'Your session has expired or the token is invalid. Please log in again.'
      );
    }
  };

  const handleUnauthorized = (error: HttpErrorResponse) => {
    if (error.status === 401) {
      showSessionExpiredMessage();
      accountService.logout();
    }
    return throwError(() => error);
  };

  const forwardRequest = (request: typeof req) =>
    next(request).pipe(catchError(handleUnauthorized));

  if (!token && isPublicEndpoint) {
    return forwardRequest(req);
  }

  if (!token && !isPublicEndpoint) {
    showSessionExpiredMessage();
    accountService.logout();
    return throwError(
      () => new HttpErrorResponse({ status: 401, statusText: 'Token no disponible' })
    );
  }

  const cloned = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return forwardRequest(cloned);
};
